import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../config/api-config';
import { AgentPresenceStatus } from './presence-hub.service';

export interface AgentPresenceDto {
  userId: string;
  status: AgentPresenceStatus;
  lastHeartbeatAtUtc: string;
  statusChangedAtUtc: string;
}

/** Backs a freshly-opened tab's initial "who's online" render -- PresenceHubService's
 * AgentPresenceChanged broadcast is what keeps it live afterward. */
@Injectable({ providedIn: 'root' })
export class PresenceApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  getOrganizationPresence(): Observable<AgentPresenceDto[]> {
    return this.http.get<AgentPresenceDto[]>(`${this.baseUrl}/v1/presence`);
  }
}
